import React, { useEffect, useState } from 'react';
import { Heading } from '../../components';
import { richText } from '../../util/richText';

import css from './ListingPage.module.css';

const getMinText = text => {
  const textLength = text.split('').length;
  if (textLength > 300) {
    return text.slice(1, 300) + '...';
  } else return text;
};

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionTextMaybe = props => {
  const { text, heading, showAsIngress = false } = props;
  const [visibleText, setVisibleText] = useState(getMinText(text));
  useEffect(() => {
    setVisibleText(getMinText(text));
  }, [text]);

  const textClass = showAsIngress ? css.ingress : css.text;
  const content = richText(text, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });

  return text ? (
    <section className={css.sectionText}>
      {heading ? (
        <Heading as="h2" rootClassName={css.sectionHeading}>
          {heading}
        </Heading>
      ) : null}
      <p className={textClass}>
        {visibleText}
        {visibleText === text ? null : (
          <span
            onClick={() => setVisibleText(text)}
            style={{ color: '#C0C0C0', marginLeft: '10px', cursor: 'pointer' }}
          >
            Mostrar más{' '}
          </span>
        )}
      </p>
    </section>
  ) : null;
};

export default SectionTextMaybe;
